import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import './dashboard-discount.container.sass';
import { useDispatch, useSelector } from 'react-redux';
import { useDebounce } from 'use-lodash-debounce';
import {
  getCategories,
  getDiscounts,
  getFlatCategories,
  getFlatDiscounts,
  getIsDataFetched, postDiscounts,
} from './dashboard-discount.slice';
import { getTeamVendorId } from '../../login/session.slice';
import { TableRow } from '../../../components/interface/table/tableRow';
import { Input } from '../../../components/interface/input/input';
import { unwrapResult } from '@reduxjs/toolkit';
import { ReactComponent as IconMinus } from '../../../assets/icons/minus.svg';
import { ReactComponent as IconPlus } from '../../../assets/icons/plus.svg';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Preloader } from '../../../components/interface/preloader/preloader';

//const FormSchema = Yup.object({
//  categories: Yup.object().of(Yup.object().shape({
//    first_time_value: Yup.string().max(3),
//    regular_value: Yup.string().max(3),
//    first_time_max_price: Yup.string()
//  })),
//  types: Yup.object().of(Yup.object().shape({
//    first_time_value: Yup.number().max(3),
//    regular_value: Yup.string().max(3),
//    first_time_max_price: Yup.string()
//  }))
//});

const GENERAL_ID = '00000000-0000-0000-0000-000000000001';
const SAMI_SWOI_ID = '00000000-0000-0000-0000-000000000002';
export const DashboardDiscountContainer = () => {

  const dispatch = useDispatch();
  const sessionData = useSelector(state => state.session);
  const discountData = useSelector(state => state.dashboardDiscounts);
  const vendorId = getTeamVendorId(sessionData);
  const [categoriesExpanded, setCategoriesExpanded] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const categoriesList = discountData.categories;
  const categories = getFlatCategories(discountData);
  const discounts = getFlatDiscounts(discountData);
  const isDataFetched = getIsDataFetched(discountData);

  const formik = useFormik({
    initialValues: {
      ...discountData.discounts
    },
    //validationSchema: FormSchema,
    enableReinitialize: true,
  });
  const [value, setValue] = useState();
  const debouncedValue = useDebounce(value, 1000);

  useEffect(() => {
    dispatch(getDiscounts({vendorId}));
    dispatch(getCategories({})).then(unwrapResult).then( data => {
      const _obj = {};
      data.map( e => {
        _obj[e.id] = false;
      });
      setCategoriesExpanded(_obj);
    });
  }, []);

  useEffect(() => {
    if(isSubmitted) {
      dispatch(postDiscounts({vendorId: vendorId, discountsModel: formik.values})).then(unwrapResult)
        .then( data => {
          toast.success('Dane zapisane!');
          formik.setValues(data);
        })
        .catch(e => {
          formik.setValues(discountData.discounts);
          if (e?.response?.data?.errors?.regular_value) {
            toast.error('Wartość zniżki nie może być mniejsza niż 10%');
          } else {
            toast.error('Cos poszło nie tak :(');
          }
        });
    }
  }, [debouncedValue]);

  const data = categoriesList;

  const _preOnChange = (e, maxValue = 100) => {
    if (e.target.value > maxValue) {
      e.target.value = maxValue;
    }
  };

  const toggleExpand = (categoryId) => {
    const val = !categoriesExpanded[categoryId];
    setCategoriesExpanded({...categoriesExpanded, [categoryId] : val});
  };

  const renderHeader = () => {
    return <TableRow classNames='vv-dashboard-discount-rows'>
      <div data-flex={1}>
        <span>Rodzaj</span>
      </div>
      <div data-flex={0.2}/>
      <div data-flex={1}>
        <span>Regularna, total (dla użytkownika)</span>
      </div>
      <div data-flex={0.2}/>
      <div data-flex={1}>
        <span>Pierwszy raz, total (dla użytkownika)</span>
      </div>
      <div data-flex={0.2}/>
      <div data-flex={1}>
        <span>Kwota maksymalna</span>
      </div>
    </TableRow>;
  };

  const _onCategoryChange = (value, categoryId, fieldName) => {
    const parent = formik.values.types[categories[categoryId].parentId];
    if(Number(parent[fieldName]) !== Number(value)) {
      const _types = JSON.parse(JSON.stringify(formik.values.types));
      _types[categories[categoryId].parentId][fieldName] = 0;
      formik.setValues({ types: _types, categories: formik.values.categories, general: formik.values.general });
    }
  };

  const renderSubCategoryRow = (e, i) => {
    return <TableRow key={i} classNames='vv-dashboard-discount-rows'>
      <div data-flex={1} style={{marginLeft: 50}}>
        <span>{e.label}</span>
      </div>
      <div data-flex={0.2}/>
      <div data-flex={1}>
        <Input
          name={`categories[${e.id}].regular_value`}
          id={`categories.${e.id}.regular_value`}
          onChange={el => {
            _preOnChange(el);
            _onCategoryChange(el.target.value, e.id, 'regular_value');
            formik.handleChange(el);
          }}
          onBlur={formik.handleBlur}
          type='number'
          value={formik.values?.categories?.[e.id]?.regular_value}
          placeholderAfterValue={`(${formik.values?.categories?.[e.id]?.user_regular_value})`}
          permanentPlaceholder='%'
          defaultValue={discounts[e.id].regular_value}/>
      </div>
      <div data-flex={0.2}/>
      <div data-flex={1}>
        <Input
          name={`categories[${e.id}].first_time_value`}
          id={`categories.${e.id}.first_time_value`}
          onChange={ el => {
            _preOnChange(el);
            _onCategoryChange(el.target.value, e.id, 'first_time_value');
            formik.handleChange(el);
          }}
          onBlur={formik.handleBlur}
          type='number'
          value={formik.values?.categories?.[e.id]?.first_time_value}
          permanentPlaceholder='%'
          placeholderAfterValue={`(${formik.values?.categories?.[e.id]?.user_first_time_value})`}
          defaultValue={discounts[e.id].first_time_value}/>
      </div>
      <div data-flex={0.2}/>
      <div data-flex={1}>
        <Input
          name={`categories[${e.id}].first_time_max_price`}
          id={`categories.${e.id}.first_time_max_price`}
          onChange={ el => {
            _preOnChange(el, 1000);
            _onCategoryChange(el.target.value, e.id, 'first_time_max_price');
            formik.handleChange(el);
          }}
          maxLength={1000}
          onBlur={formik.handleBlur}
          value={formik.values?.categories?.[e.id]?.first_time_max_price}
          permanentPlaceholder='zł'
          defaultValue={discounts[e.id].first_time_max_price}/>
      </div>
    </TableRow>;
  };

  const _updateAll = (categoryId, value, field) => {
    if(value === undefined) {
      return;
    }
    const formCategories = JSON.parse(JSON.stringify(formik.values.categories));
    categories[categoryId].categories.map( category => {
      formCategories[category.id][field] = Number(value);
    });
    formik.setValues({categories: formCategories, types: formik.values.types, general: formik.values.general, 'all-friends-here': formik.values['all-friends-here'] });
  };

  const renderRows = () => {
    return data.map((e, i) => {
      return <>
        <TableRow key={i} classNames='vv-dashboard-discount-rows vv-dashboard-discount-category-header'>
          <div data-flex={1} style={{display: 'flex'}}>
            {categoriesExpanded[e.id] ? <IconMinus onClick={() => toggleExpand(e.id)}/> : <IconPlus onClick={() => toggleExpand(e.id)}/>}
            <span>{e.label} (wszystkie) </span>
          </div>
          <div data-flex={0.2}/>
          <div data-flex={1}>
            <Input name={`types[${e.id}].regular_value`}
                   id={`types.${e.id}.regular_value`}
                   onChange={el => {
                     _preOnChange(el);
                     _updateAll(e.id, el.target.value, 'regular_value');
                     formik.handleChange(el);
                   }}
                   type='number'
                   onBlur={formik.handleBlur}
                   value={formik.values?.types?.[e.id]?.regular_value}
                   placeholderAfterValue={`(${formik.values?.types?.[e.id]?.user_regular_value})`}
                   permanentPlaceholder='%'
                   defaultValue={discounts[e.id].regular_value}/>
          </div>
          <div data-flex={0.2}/>
          <div data-flex={1}>
            <Input name={`types[${e.id}].first_time_value`}
                   id={`types.${e.id}.first_time_value`}
                   onChange={el => {
                     _preOnChange(el);
                     _updateAll(e.id, el.target.value, 'first_time_value');
                     formik.handleChange(el);
                   }}
                   onBlur={formik.handleBlur}
                   type='number'
                   value={formik.values?.types?.[e.id]?.first_time_value}
                   textError={formik.touched.types?.[i]?.first_time_value && formik.errors.types?.[i]?.first_time_value}
                   placeholderAfterValue={`(${formik.values?.types?.[e.id]?.user_first_time_value})`}
                   permanentPlaceholder='%'
                   defaultValue={discounts[e.id].first_time_value}/>
          </div>
          <div data-flex={0.2}/>
          <div data-flex={1}>
            <Input name={`types[${e.id}].first_time_max_price`}
                   id={`types.${e.id}.first_time_max_price`}
                   onChange={el => {
                     _preOnChange(el, 1000);
                     _updateAll(e.id, el.target.value, 'first_time_max_price');
                     formik.handleChange(el);
                   }}
                   maxLength={1000}
                   onBlur={formik.handleBlur}
                   value={formik.values?.types?.[e.id]?.first_time_max_price}
                   permanentPlaceholder='zł'
                   defaultValue={discounts[e.id].first_time_max_price}/>
          </div>
        </TableRow>
        { categoriesExpanded[e.id] ? e.categories.map(renderSubCategoryRow) : null}
      </>;
    });
  };

  const renderSingleRow = (label, property, subProperty) => {
    if(discounts[subProperty]?.regular_value === undefined) {
        return;
    }

    return <TableRow classNames='vv-dashboard-discount-rows vv-dashboard-discount-category-header'>
      <div data-flex={1} style={{display: 'flex'}}>
        <span>{label}</span>
      </div>
      <div data-flex={0.2}/>
      <div data-flex={1}>
        <Input name={`${property}[${subProperty}].regular_value`}
               id={`${property}.${subProperty}.regular_value`}
               onChange={el => {
                 _preOnChange(el);
                 formik.handleChange(el);
               }}
               type='number'
               onBlur={formik.handleBlur}
               value={formik.values?.[property]?.[subProperty]?.regular_value}
               placeholderAfterValue={`(${formik.values?.[property]?.[subProperty]?.user_regular_value})`}
               permanentPlaceholder='%'
               defaultValue={discounts[subProperty]?.regular_value}/>
      </div>
      <div data-flex={0.2}/>
      <div data-flex={1}>
        <Input name={`${property}[${subProperty}].first_time_value`}
               id={`${property}.${subProperty}.first_time_value`}
               onChange={el => {
                 _preOnChange(el);
                 formik.handleChange(el);
               }}
               onBlur={formik.handleBlur}
               type='number'
               value={formik.values?.[property]?.[subProperty]?.first_time_value}
               textError={formik.touched?.[property]?.[subProperty]?.first_time_value && formik.errors?.[property]?.[subProperty]?.first_time_value}
               placeholderAfterValue={`(${formik.values?.[property]?.[subProperty]?.user_first_time_value})`}
               permanentPlaceholder='%'
               defaultValue={discounts[subProperty]?.first_time_value}/>
      </div>
      <div data-flex={0.2}/>
      <div data-flex={1}>
        <Input name={`${property}[${subProperty}].first_time_max_price`}
               id={`${property}.${subProperty}.first_time_max_price`}
               onChange={el => {
                 formik.handleChange(el);
               }}
               maxLength={1000}
               onBlur={formik.handleBlur}
               value={formik.values?.[property]?.[subProperty]?.first_time_max_price}
               permanentPlaceholder='zł'
               defaultValue={discounts[subProperty]?.first_time_max_price}/>
      </div>
    </TableRow>;
  };

  return isDataFetched ? (
   <form onChange={() => {
     setIsSubmitted(true);
     setValue(formik.values);
   }} className='vv-dashboard-discount-container'>
     <h2>Zniżki</h2>
     {renderHeader()}
     {renderSingleRow('Zniżka bez biletu', 'general', GENERAL_ID)}
     {/*{renderSingleRow('Sami swoi - zniżka dla innych Vendorów z Viceversa','all-friends-here', SAMI_SWOI_ID)}*/}
     {renderRows()}
   </form>
  ) : <Preloader isVisible={true}/>;
};
